import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL;

export const saveProductView = async ({ email, value }) => {
  const payload = {
    email, // e.g. user’s email
    value, // e.g. product slug or anything you’d like to identify this product
  };

  try {
    const response = await axios.post(
      `${baseUrl}/api/ColtecAdmin/SaveProductView`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error saving product view:", error);
    throw error;
  }
};
